import CheckboxGroup from './checkbox-group-view'

export default CheckboxGroup
